import React from "react";

export const Loading = ({ label }: { label: string }) => (
	<div className="addtocart-spinner" aria-live="assertive" role="alert">
		{label}
	</div>
);
